// This empty function is intentional
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop() {}

export function identity<T>(value: T): T {
    return value
}
